import { forwardRef, LabelHTMLAttributes } from "react";
import { useFormGroup } from "../FormGroup/FormGroup";
import { cn } from "../../../utils/cn";

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  "data-testid"?: string;
}

/**
 *
 */
export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  (
    {
      className,
      children,
      required,
      "data-testid": dataTestId,
      ...props
    }: LabelProps,
    ref,
  ) => {
    const css = cn("pl-1 text-sm mb-1 block", className);

    const formGroup = useFormGroup();

    // Auto-generate data-testid from children or formGroup id if not provided
    const generateTestId = () => {
      if (dataTestId) return dataTestId;
      if (typeof children === "string" && children) {
        const sanitized = children
          .toLowerCase()
          .trim()
          .replace(/\s+/g, "-")
          .replace(/[^a-z0-9-]/g, "");
        return sanitized ? `label-${sanitized}` : "label";
      }
      if (formGroup?.id) return `label-${formGroup.id}`;
      return "label";
    };

    const testId = generateTestId();

    return (
      <label
        ref={ref}
        className={css}
        htmlFor={formGroup?.id}
        data-testid={testId}
        {...props}
      >
        {children}
        {!!required && (
          <span className="relative -top-1 ml-[0.1rem] text-orange-600">*</span>
        )}
      </label>
    );
  },
);
Label.displayName = "label";
